export default __webpack_public_path__ + "static/media/72.087a8e2a.gif";